export const SUPPORTED_LEXILES = [
  { title: '320L', value: '320L' },
  { title: '370L', value: '370L' },
  { title: '420L', value: '420L' },
  { title: '470L', value: '470L' },
  { title: '520L', value: '520L' },
  { title: '570L', value: '570L' },
  { title: '620L', value: '620L' },
  { title: '670L', value: '670L' },
  { title: '720L', value: '720L' },
  { title: '770L', value: '770L' },
  { title: '820L', value: '820L' },
  { title: '870L', value: '870L' },
  { title: '920L', value: '920L' },
  { title: '970L', value: '970L' },
  { title: '1020L', value: '1020L' },
  { title: '1070L', value: '1070L' },
  { title: '1120L', value: '1120L' },
  { title: '1170L', value: '1170L' },
  { title: '1220L', value: '1220L' },
];

export interface ReadingSpeedThreshold {
  ok: number;
  good: number;
}
export const READING_SPEED_THRESHOLDS_BY_LEXILE: Record<
  string,
  ReadingSpeedThreshold
> = {
  '320L': { ok: 25, good: 45 },
  '370L': { ok: 30, good: 50 },
  '420L': { ok: 30, good: 55 },
  '470L': { ok: 40, good: 70 },
  '520L': { ok: 45, good: 80 },
  '570L': { ok: 50, good: 85 },
  '620L': { ok: 50, good: 90 },
  '670L': { ok: 55, good: 95 },
  '720L': { ok: 55, good: 100 },
  '770L': { ok: 60, good: 105 },
  '820L': { ok: 65, good: 110 },
  '870L': { ok: 65, good: 115 },
  '920L': { ok: 70, good: 120 },
  '970L': { ok: 70, good: 125 },
  '1020L': { ok: 75, good: 130 },
  '1070L': { ok: 80, good: 135 },
  '1120L': { ok: 80, good: 140 },
  '1170L': { ok: 80, good: 145 },
  '1220L': { ok: 85, good: 150 },
};
